import { useEffect } from "react";
import { Card, Table } from "react-bootstrap";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { getEvents } from "../api/api";
import { IMessage } from "../types/news";
import i18n from "../i18n";

const EventCenter = ({ limit = 5 }) => {
  const { t, i18n } = useTranslation();
  const { isLoading, error, data, refetch }: any = useQuery(
    "EventsData",
    () => getEvents({ limit, language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading) return <div>{t("misc.loading")}</div>;
  if (error) return <div>{t("event_center.error_loading")}</div>;

  return (
    <div className="events-center">
      <Card className="shadow">
        <Card.Body>
          <Card.Title>{t("event_center.title")}</Card.Title>
          <div className="table-responsive">
            {data.data.length > 0 && (
              <Table size="sm">
                <tbody>
                  {data.data.map((newsItem: IMessage) => (
                    <MessagesItem key={newsItem.id} data={newsItem} />
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

interface ISMessagesItemProps {
  data: IMessage;
}

const MessagesItem = ({ data }: ISMessagesItemProps) => {
  const eventDate = new Date(data.attributes.Date);
  const day = eventDate.toLocaleDateString("en-US", { day: "2-digit" });
  const month = eventDate.toLocaleDateString(i18n.language, { month: "short" });

  return (
    <tr>
      <td>
        <div className="events-view-subject">{data.attributes.Title}</div>
      </td>
      <td className="events-view-date-cell">
        <div className="events-view-day en_font">{day}</div>
        <div className="events-view-month en_font">{month}</div>
      </td>
    </tr>
  );
};

export default EventCenter;
